import { IconCat } from "@tabler/icons-react";

function AnimalHeader({ animal }) {
  return (
    <div className="sticky top-0 flex items-center gap-8 text-lg p-8 bg-white shadow-lg">
      <div className="h-24 w-24 border rounded-md">
        {animal?.image ? (
          <img alt="..." src={animal.image} />
        ) : (
          <div className="flex items-center justify-center h-full">
            <IconCat className="h-24 w-24" />
          </div>
        )}
      </div>
      <div className="flex items-center justify-between w-full">
        <div>
          <div className="text-2xl font-semibold">{animal.name}</div>
          <div>
            {animal.sex === 1
              ? "Male"
              : animal.sex === 2
                ? "Female"
                : "Unknown"}
          </div>
          <div>
            {animal.color} ({animal.coat})
          </div>
        </div>
        <div>
          <div className="flex items-center justify-between w-full gap-2">
            Database Id:
            <span className="font-semibold ms-auto ">
              {animal?.animalId?.toString().padStart(4, "0")}
            </span>
          </div>
          <div className="flex items-center justify-between w-full">
            All4Cats Id:{" "}
            <span className="font-semibold ms-auto">{animal.all4CatsId}</span>
          </div>
          <div className="flex items-center justify-between w-full gap-8">
            Birthday:{" "}
            <span className="font-semibold ms-auto">
              {new Date(animal.birthDate).toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnimalHeader;
